<ng-container>
	<div id="shotdialog_div">
		<mat-card-header>
			<div
				fxLayout="row"
				fxLayoutAlign="space-between"
				style="margin-bottom: 10px; margin-top: 10px; width: 100%"
			>
				<div fxLayout="row" style="align-items: center; display: flex; width: 100%; justify-content: left; gap: 50px" class="mobile-shotdata-dialog-title">
					<div style="display: flex;">
						<img
							src="/icons/swing_data_result.png"
							style="
								width: 16px;
								height: 22px;
								margin-right: 10px;
							"
						/>
						<div class="detail_title mobile-font-14" translate>
							スイングデータ詳細
						</div>
					</div>

					<div>
						<button
							*ngIf="2 > 1 || user.advice_permission"
							(click)="handleRequestOrShowAdvice()"
							style="
								padding: 4xp;
								display: flex;
								justify-content: space-between;
								align-items: center;
							"
							[class]="
								'mat-focus-indicator mat-raised-button mat-button-base create-request-review ' +
								(isAllowAdvice()
									? 'mat-warn cursor-pointer'
									: 'cursor-auto')
							"
							color="warn"
						>
							<span>
								{{
									_.get(this.shot, "request_advice")
										? "AIアドバイス済"
										: "AIアドバイス"
								}}
								<!-- {{
									_.get(calculateDiagnoseResult, "advicePartCode", "")
								}} -->
							</span>
							<span
								*ngIf="isRequestingAdvice"
								style="margin-left: 10px"
							>
								<mat-spinner diameter="30"></mat-spinner>
							</span>
						</button>
					</div>
				</div>

				<!-- <div
					fxLayout="row"
					(click)="cancel()"
					style="align-items: center"
				>
					<img
						src="/icons/close.png"
						style="width: 18px; height: 22px; cursor: pointer"
					/>
				</div> -->
			</div>
		</mat-card-header>
		<mat-dialog-content
			ngClass.xs="mat-dialog-content_xs"
			ngClass.lt-md="mat-dialog-content_xs"
		>
			<aigia-shot [data]="data.shot"></aigia-shot>
		</mat-dialog-content>
		<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between">
			<div fxLayout="row">
				<button
					(click)="onDelete($event, data.shot._id)"
					class="delete_btn"
					mat-raised-button
				>
					<mat-icon>delete</mat-icon>
					<span style="padding-left: 8px" translate>削除</span>
				</button>
				<button
					(click)="onViewMemo()"
					class="memo_btn have"
					mat-raised-button
				>
					<mat-icon>note_alt</mat-icon>
					<span style="padding-left: 8px" translate>メモ</span>
				</button>
			</div>
			<div fxLayout="row">
				<button
					(click)="cancel()"
					class="close_btn"
					mat-dialog-close=""
					mat-raised-button
				>
					<mat-icon>close</mat-icon>
					<span translate>閉じる</span>
				</button>
			</div>
		</mat-dialog-actions>
		<div
			*ngIf="showConfirmDialog"
			style="
				position: absolute;
				top: 0px;
				left: 0px;
				width: 100%;
				height: 100%;
				z-index: 10000;
				display: flex;
				justify-content: center;
				align-items: center;
			"
		>
			<div
				style="
					width: calc(min(90%, 500px));
					max-width: 100%;
					background: #1f2937;
					height: 240px;
					border: 2px solid white;
				"
			>
				<div
					mat-dialog-title
					style="
						padding: 0px;
						margin: 0px;
						margin-top: 10px;
						color: #ffffff;
					"
				>
					<div
						fxLayout="row"
						style="
							justify-content: center;
							padding-top: 20px;
							padding-bottom: 10px;
						"
					>
						<div
							class="card-title"
							style="font-size: 22px; font-weight: 510"
						>
							AIアドバイスを
						</div>
					</div>
				</div>

				<mat-dialog-content fxFlexAlign="center center">
					<div fxLayout="row" style="justify-content: center">
						<div
							fxLayout="column"
							style="
								font-size: 22px;
								color: white;
								text-align: center;
								font-weight: 510;
							"
						>
							<p style="margin: 22px">リクエストしますか？</p>
						</div>
					</div>
				</mat-dialog-content>

				<div class="spacer"></div>

				<mat-dialog-actions
					fxLayout="row"
					fxLayout.lt-sm="row"
					fxLayoutAlign="center"
					style="padding: 20px"
				>
					<button
						(click)="agreeSendAdviceRequest()"
						class="red-button"
						mat-raised-button
						style="margin-right: 10px; padding: 2px 25px"
					>
						はい
					</button>

					<button
						(click)="cancelSendAdviceRequest()"
						class="transparent-button"
						mat-raised-button
						style="padding: 2px 25px"
					>
						いいえ
					</button>
				</mat-dialog-actions>
			</div>
		</div>
	</div>
</ng-container>
